// tag-clientes-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Cadastrado": "Registrado",
    "Cadastro no app": "Registro en la app",
    "Cliente desde": "Cliente desde",
    "Pré-cadastro": "Prerregistro",
};

export default catalogo;
